/**************************************************
 * Nombre:       Home_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Testimonio from "../../Tarjetas/Tarjeta_Testimonio";
import foto from '../../../Recursos/testis/paula.jpeg'
import carla from '../../../Recursos/testis/carla.jpeg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Testimonios = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Splide
                        //ref={refe}
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: 1,
                            arrows: false,
                            perMove: 1,
                            pagination: true,
                            width: '100%',
                            drag: 'free',
                            snap: true,
                            interval: 5000,
                            noDrag: true,
                            focus: 'center',
                            type: 'loop',
                            padding: '0rem',
                            gap: 150,

                        }}
                    >

                        {items.map((item, index) => {
                            return (
                                <SplideSlide key={`qer${index}`}>
                                    <Tarjeta_Testimonio item={item}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Testimonios

const items = [
    {
        nombre: 'Mauricio Salas',
        img: foto,
        tipo: 'Turista',
        testimonio: 'Limpio y económico comparado a otros hoteles del sector. Lo más importante es encontrar un lugar acogedor y este hotel cuenta con eso'
    },
    {
        nombre: 'Cadison Myller',
        img: carla,
        tipo: 'Turista Extranjero',
        testimonio: 'Viaje para ver las ballenas, me diero buena informacion del hotel, me gusto la personas que atendian y lo amables que fueron, me guiaron muy bien'
    },
]